// src/pages/Attendance/Form/SoundStore.ts
import deleteSoundFile from 'assets/sounds/delete.wav';
import successSoundFile from 'assets/sounds/success.wav';
import errorSoundFile from 'assets/sounds/error.wav';
import { soundData } from './soundData';
import { base64ToArrayBuffer } from 'utils/base64ToArrayBuffer';

type SoundName = 'touch' | 'success' | 'error' | 'delete';

const AudioContextCtor =
  window.AudioContext || (window as any).webkitAudioContext;
const audioCtx: AudioContext = new AudioContextCtor();

function decodeAudioDataAsync(ctx: AudioContext, data: ArrayBuffer) {
  return new Promise<AudioBuffer>((resolve, reject) => {
    ctx.decodeAudioData(data.slice(0), resolve, reject);
  });
}

async function loadUrlAsBuffer(url: string) {
  const res = await fetch(url);
  const arr = await res.arrayBuffer();
  return decodeAudioDataAsync(audioCtx, arr);
}

export default class SoundStore {
  private unlocked = false;
  private buffers: Partial<Record<SoundName, AudioBuffer>> = {};

  constructor() {
    // 미리 디코드 시작(권한과 무관)
    decodeAudioDataAsync(audioCtx, base64ToArrayBuffer(soundData))
      .then((b) => (this.buffers.touch = b))
      .catch(() => {
        console.log('decodeAudioDataAsync error');
      });

    Promise.all([
      loadUrlAsBuffer(successSoundFile).then((b) => (this.buffers.success = b)),
      loadUrlAsBuffer(errorSoundFile).then((b) => (this.buffers.error = b)),
      loadUrlAsBuffer(deleteSoundFile).then((b) => (this.buffers.delete = b)),
    ]).catch(() => {
      console.log('loadUrlAsBuffer error');
    });

    const unlock = () => {
      if (this.unlocked) return;
      this.unlocked = true;
      audioCtx.resume().catch(() => {
        console.log('audioCtx resume error');
      });
      // 무음 1샷(일부 Android/WebView에서 안정성↑)
      try {
        const silent = audioCtx.createBuffer(1, 1, audioCtx.sampleRate);
        const src = audioCtx.createBufferSource();
        src.buffer = silent;
        src.connect(audioCtx.destination);
        src.start(0);
      } catch {}
    };

    window.addEventListener('pointerdown', unlock, { once: true });
    window.addEventListener('keydown', unlock, { once: true });
    window.addEventListener('touchstart', unlock, { once: true });
  }

  playSound = (name: SoundName) => {
    if (!this.unlocked) return;

    const buf = this.buffers[name];
    if (!buf) return;

    audioCtx.resume().catch(() => {
      console.log('playSound audioCtx result error');
    });
    const src = audioCtx.createBufferSource();
    src.buffer = buf;
    src.connect(audioCtx.destination);
    try {
      src.start(0);
    } catch {}
  };
}
